// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserPhones_wrapper__2ivOK","phones":"UserPhones_phones__WRD3e","phone":"UserPhones_phone__1R6_L"};